'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindActions = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _handlers = require('./handlers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bindActions = exports.bindActions = function bindActions() {
  $(_Dom2.default.faqMenuBtn).on('click', function () {
    return $(_Dom2.default.faqMenu).addClass('active');
  });

  $(_Dom2.default.faqMenuClose).on('click', function () {
    return $(_Dom2.default.faqMenu).removeClass('active');
  });

  window.addEventListener('resize', function () {
    (0, _handlers.fixNav)();
    $(_Dom2.default.faqNav).trigger('detach');
  });
};